const useLogHelpers = require('./mixin');
const makeEverythingAttachToOTHelpers = require('../makeEverythingAttachToOTHelpers');

const logging = exports;
useLogHelpers(logging);

makeEverythingAttachToOTHelpers(logging);



// WEBPACK FOOTER //
// ./src/js/common-js-helpers/logging/index.js